// extracted by mini-css-extract-plugin
export default {"container":"ClaimedIBAN_container__GdpY8","title":"ClaimedIBAN_title__D5I0G","paragraph":"ClaimedIBAN_paragraph__mhsRe","buttonContainer":"ClaimedIBAN_buttonContainer__yENFG"};